const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const WorkAssignmentCommandURL = {
    Reassign: (featureKey: string) => Backofficebff + `/v1/work-assignment/${featureKey}/reassign`,
};
